import { FC, useState } from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import ListIcon from "@mui/icons-material/List";
import GridViewIcon from "@mui/icons-material/GridView";
import { State, setCurrentMediaView } from "../../../../../../shell/store/media-revamp";
import { useSelector, useDispatch } from "react-redux";
export const ToggleViews = () => {
  const dispatch = useDispatch();
  const currentMediaView = useSelector((state: {
    mediaRevamp: State;
  }) => state.mediaRevamp.currentMediaView);
  return <ToggleButtonGroup value={currentMediaView} size="small" exclusive onChange={(e, val) => dispatch(setCurrentMediaView(val))} color="primary" data-sentry-element="ToggleButtonGroup" data-sentry-component="ToggleViews" data-sentry-source-file="ToggleViews.tsx">
      <ToggleButton value="grid" data-sentry-element="ToggleButton" data-sentry-source-file="ToggleViews.tsx">
        <GridViewIcon fontSize="inherit" data-sentry-element="GridViewIcon" data-sentry-source-file="ToggleViews.tsx" />
      </ToggleButton>
      <ToggleButton value="list" data-sentry-element="ToggleButton" data-sentry-source-file="ToggleViews.tsx">
        <ListIcon fontSize="inherit" data-sentry-element="ListIcon" data-sentry-source-file="ToggleViews.tsx" />
      </ToggleButton>
    </ToggleButtonGroup>;
};